/* eslint-disable spire/export-styles */
import translate from "@insite/client-framework/Translate";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import ChevronRight from "@insite/mobius/Icons/ChevronRight";
import Link from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import * as React from "react";
import { css } from "styled-components";

interface OwnProps {
    heading: string;
    viewAllUrl?: string;
}
const CardListHeading: React.FunctionComponent<OwnProps> = ({ heading, viewAllUrl }) => {
    return (
        <GridItem width={12}>
            <GridContainer
                offsetCss={css`
                    background-color: ${getColor("info.contrast")};
                    border-radius: 4px;
                    &&& {
                        width: 100%;
                        margin: 0;
                    }
                `}
            >
                <GridItem width={8} style={{ padding: "10px 15px" }}>
                    <Typography variant="h5" className="card-list-heading" style={{ marginBottom: "0px" }}>
                        {heading}
                    </Typography>
                </GridItem>
                {viewAllUrl && (
                    <GridItem width={4} style={{ padding: "8px 15px" }}>
                        <Link
                            href={viewAllUrl}
                            // icon={{ iconProps: { src: ChevronRight } }}
                            typographyProps={{ size: 16 }}
                            css={css`
                                margin-left: auto;
                                margin-top: 5px;
                                font-weight: bold;
                            `}
                            className="view-all-link"
                            data-test-selector="cardListHeadingViewAllLink"
                        >
                            {translate("View All")}
                            <VisuallyHidden>
                                {translate("View All")} {heading}
                            </VisuallyHidden>
                        </Link>
                    </GridItem>
                )}
            </GridContainer>
        </GridItem>
    );
};

export default CardListHeading;
